import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const propertyTenantedService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    PROPERTY: 'properties',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            group: filter?.group,
            property_type: filter?.propertyType,
            is_tenanted: 1,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PROPERTY}`, request);
}

export function store (data) {
    const formData = new FormData();
    formData.append(`_method`, 'POST');

    if (data.property) {
        if (data.property.groupUuid) formData.append(`property[group_uuid]`, data.property.groupUuid);
        if (data.property.propertyTypeUuid) formData.append(`property[property_type_uuid]`, data.property.propertyTypeUuid);
        if (data.property.locationUuid) formData.append(`property[location_uuid]`, data.property.locationUuid);
        if (data.property.registeredOwner) formData.append(`property[registered_owner]`, data.property.registeredOwner);
        if (data.property.company) formData.append(`property[company]`, data.property.company);
        if (data.property.description) formData.append(`property[description]`, data.property.description);
        if (data.property.remark) formData.append(`property[remark]`, data.property.remark);
        if (data.property.address1) formData.append(`property[address_1]`, data.property.address1);
        if (data.property.address2) formData.append(`property[address_2]`, data.property.address2);
        if (data.property.address3) formData.append(`property[address_3]`, data.property.address3);
        if (data.property.city) formData.append(`property[city]`, data.property.city);
        if (data.property.state) formData.append(`property[state]`, data.property.state);
        if (data.property.postcode) formData.append(`property[postcode]`, data.property.postcode);
        if (data.property.lat) formData.append(`property[lat]`, data.property.lat);
        if (data.property.lng) formData.append(`property[lng]`, data.property.lng);
        if (data.property.image instanceof File) formData.append('property[image]', data.property.image);
        formData.append(`property[is_asset]`, data.property.isAsset);
        formData.append(`property[is_tenanted]`, data.property.isTenanted);
        formData.append(`property[is_malaysia]`, data.property.isMalaysia);
        formData.append(`property[is_personal]`, data.property.isPersonal);  
    }

    if (data.tenanted) {
        if (data.tenanted.landlord) formData.append(`tenanted[landlord]`, data.tenanted.landlord);
        if (data.tenanted.purpose) formData.append(`tenanted[purpose]`, data.tenanted.purpose);
        if (data.tenanted.dateCommenced) formData.append(`tenanted[date_commenced]`, data.tenanted.dateCommenced);
        if (data.tenanted.dateExpired) formData.append(`tenanted[date_expired]`, data.tenanted.dateExpired);
        if (data.tenanted.tenureYear) formData.append(`tenanted[tenure_year]`, data.tenanted.tenureYear);
        if (data.tenanted.rentalPayment) formData.append(`tenanted[rental_payment]`, data.tenanted.rentalPayment);
    }

    return apiHelper(API_URL).post(`/${MODULE.PROPERTY}`, formData);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PROPERTY}/${uuid}`);
}

export function update (data) {
    const formData = new FormData();
    formData.append(`_method`, 'PUT');

    if (data.property) {
        if (data.property.groupUuid) formData.append(`property[group_uuid]`, data.property.groupUuid);
        if (data.property.propertyTypeUuid) formData.append(`property[property_type_uuid]`, data.property.propertyTypeUuid);
        if (data.property.locationUuid) formData.append(`property[location_uuid]`, data.property.locationUuid);
        if (data.property.registeredOwner) formData.append(`property[registered_owner]`, data.property.registeredOwner);
        if (data.property.company) formData.append(`property[company]`, data.property.company);
        if (data.property.description) formData.append(`property[description]`, data.property.description);
        if (data.property.remark) formData.append(`property[remark]`, data.property.remark);
        if (data.property.address1) formData.append(`property[address_1]`, data.property.address1);
        if (data.property.address2) formData.append(`property[address_2]`, data.property.address2);
        if (data.property.address3) formData.append(`property[address_3]`, data.property.address3);
        if (data.property.city) formData.append(`property[city]`, data.property.city);
        if (data.property.state) formData.append(`property[state]`, data.property.state);
        if (data.property.postcode) formData.append(`property[postcode]`, data.property.postcode);
        if (data.property.lat) formData.append(`property[lat]`, data.property.lat);
        if (data.property.lng) formData.append(`property[lng]`, data.property.lng);
        if (data.property.image instanceof File) formData.append('property[image]', data.property.image);
        formData.append(`property[is_asset]`, data.property.isAsset);
        formData.append(`property[is_tenanted]`, data.property.isTenanted);
        formData.append(`property[is_malaysia]`, data.property.isMalaysia);
        formData.append(`property[is_personal]`, data.property.isPersonal);
    }

    if (data.tenanted) {
        if (data.tenanted.landlord) formData.append(`tenanted[landlord]`, data.tenanted.landlord);
        if (data.tenanted.purpose) formData.append(`tenanted[purpose]`, data.tenanted.purpose);
        if (data.tenanted.dateCommenced) formData.append(`tenanted[date_commenced]`, data.tenanted.dateCommenced);
        if (data.tenanted.dateExpired) formData.append(`tenanted[date_expired]`, data.tenanted.dateExpired);
        if (data.tenanted.tenureYear) formData.append(`tenanted[tenure_year]`, data.tenanted.tenureYear);
        if (data.tenanted.rentalPayment) formData.append(`tenanted[rental_payment]`, data.tenanted.rentalPayment);
    }

    return apiHelper(API_URL).post(`/${MODULE.PROPERTY}/${data.uuid}`, formData);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.PROPERTY}/${data.uuid}`);
}